import { TopAnomalousReasons } from '@modules/quantify/components/QuantifyTemplates/TopAnomalousReasons';
import { TopAnomalousTrackedKeywords } from '@modules/quantify/components/QuantifyTemplates/TopAnomalousTrackedKeywords';
import { TopTrackedKeywordsTrendChart } from '@modules/quantify/components/QuantifyTemplates/TopTrackedKeywordsTrendChart';
import { ExtensionRounded } from '@mui/icons-material';
import {
  Card,
  CardActionArea,
  Grid,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import { ComplaintsForTopTrackedKeywords } from './ComplaintsForTopTrackedKeywords';
import { TopReasonsForNegativeFeedbackTemplate } from './TopReasonsForNegativeFeedbackTemplate';
import { TopRecommendedReasonsTemplate } from './TopRecommendedReasonsTemplate';

export function QuantifyTemplates({
  onExampleSelect,
}: {
  onExampleSelect: () => void;
}) {
  const renderGridExamples = () => {
    return [
      TopRecommendedReasonsTemplate,
      TopAnomalousReasons,
      TopReasonsForNegativeFeedbackTemplate,
      TopAnomalousTrackedKeywords,
      ComplaintsForTopTrackedKeywords,
      TopTrackedKeywordsTrendChart,
    ].map((Component, index) => {
      return (
        <Grid item xs={6} key={index}>
          <Card
            variant="outlined"
            sx={{
              height: '100%',
              minWidth: '140px',
            }}
            onClick={onExampleSelect}
          >
            <CardActionArea>
              <Component />
            </CardActionArea>
          </Card>
        </Grid>
      );
    });
  };

  return (
    <Stack
      data-role="quantify-templates"
      component={Paper}
      variant="outlined"
      justifyContent="center"
      alignItems="center"
      height={490}
      spacing={4}
      p={2}
      sx={{
        borderRadius: 2,
      }}
    >
      <Typography variant="subtitle1">
        👈 Configure your query to quantify feedback
      </Typography>
      <Stack direction="column" spacing={1} alignItems="center">
        <Stack direction="row" spacing={1}>
          <ExtensionRounded fontSize="small" color="disabled" />
          <Typography variant="body2" color="text.secondary">
            You can get started with these templates
          </Typography>
        </Stack>
        <Grid
          container
          spacing={2}
          pr={2}
          maxWidth="800px"
          alignItems="stretch"
        >
          {renderGridExamples()}
        </Grid>
      </Stack>
    </Stack>
  );
}
